import useFetchHelpCenter from './fetch/useFetchHelpCenter';
import useIsMobile from './useIsMobile';

export default function useHalfOpenEnabled() {
  const { data: helpCenter } = useFetchHelpCenter();
  const isMobile = useIsMobile();

  return isMobile && helpCenter?.options?.autoopen_chat_rule === 'half_open';
}
